import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AUTH_RC, AUTHORIZED_RC } from '@core/constants/routes.constants';
import { canMatchAuthorized, canMatchUnauthorized } from '@core/services/guards/auth.guard';
import { profileResolver } from '@core/services/resolvers/profile.resolver';

const routes: Routes = [
  {
    path: AUTH_RC.root,
    loadChildren: () => import('@features/auth/auth.module').then(m => m.AuthModule),
    canMatch: [canMatchUnauthorized],
  },
  {
    path: AUTHORIZED_RC.root,
    loadChildren: () =>
      import('@features/authorized-content/authorized-content.module').then(m => m.AuthorizedContentModule),
    resolve: {
      profile: profileResolver,
    },
    canMatch: [canMatchAuthorized],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
